import { Text } from '@pm/ui';
import { useTranslation } from 'react-i18next';

export const OperationHoursDisclaimer = () => {
  const { t } = useTranslation('appointments', {
    keyPrefix: 'ManageAppointment.Manage.Policies',
  });

  return <Text size="label">{t('OperationHours')}</Text>;
};
